import {FC, ReactNode} from "react";
import {Text} from "@wakelet/ui-kit";
import {translateKey} from "../language/translate";

type Props = {
  children: ReactNode,
  htmlFor: string
};

export const FieldLabel: FC<Props> = ({children, htmlFor}) => {
  return (
      <div className="mb-1">
        <Text>
          <label htmlFor={htmlFor} className="ml-3">
            {children}
            <sup className="text-gray-400">*</sup>
          </label>
        </Text>
      </div>
  );
};

export const RequiredFieldsMessage = () => (
    <p className="text-gray-600 text-sm text-right">
      <em>
        <sup>*</sup> {translateKey("account:required.field.message")}.
      </em>
    </p>
);
